module.exports = __webpack_public_path__ + "static/media/fssaiIconDelivery.ff4fc7d5.svg";